import classNames from 'classnames';
import { playSound, Sounds } from '../../models/Sounds';
import './common.scss';
import store from '../../store/store';
import { useParams } from 'react-router-dom';

export default function Button(props: {
  text: string,
  onClick: any,
  classes?: string,
  disabled?: boolean,
  confirmPrompt?: string | null,
  ignoreConnection?: boolean,
}) {

  const { gameId } = useParams();

  const gameState = store.getState().game;

  const { text, onClick, classes = '', disabled = false, ignoreConnection = false } = props;
  const buttonClass = classNames({
    'button': true,
    [classes]: true,
  });

  function onButtonClick(e: any) {
    if (!gameState.isConnected && !ignoreConnection) {
      e.preventDefault();
      return;
    }

    playSound(Sounds.CLICK);
    if (!props.confirmPrompt || window.confirm(props.confirmPrompt)) {
      onClick(e);
    }

  }

  return (
    <button
      className={buttonClass}
      disabled={disabled ||
        (!gameState.isConnected && !ignoreConnection) ||
        (gameState.gameStarted && !!gameId && !gameState.player)
      }
      onClick={onButtonClick}>
      {text}
    </button>
  )
}